import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(_component_v_card, {
      "max-width": "420",
      class: "d-inline-block"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, {
          src: _ctx.src,
          class: "white--text align-top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { innerHTML: _ctx.name }, null, 8, ["innerHTML"])
          ]),
          _: 1
        }, 8, ["src"]),
        _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              href: _ctx.src,
              block: ""
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Get", -1)
              ])),
              _: 1,
              __: [0]
            }, 8, ["href"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}